import initialClientsFilter from '@app/data/clientFilters/initialClientsFilter.json';
import { initialFilterGroups } from '@app/data/clientFilters/initialFilterGroups';
import initialVisitsFilter from '@app/data/clientFilters/initialVisitsFilter.json';
import { initialAccessRights } from '@app/data/initialAccessRights';
import { navigation } from '@app/data/navigation';

export {
  initialClientsFilter,
  initialVisitsFilter,
  navigation,
  initialFilterGroups,
  initialAccessRights,
};
